import React, { useState } from 'react';
import {
  callNumberListing,
  deleteNumber,
  didUpdate,
} from '../../../api-services';
import { useMutation, useQueryClient } from 'react-query';
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import NumberDetails from '../NumberDetails';
import {
  openModalGlobal,
  openUserDetailsModal,
} from '../../../redux/features/modalSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faTrash,
  faEllipsisV,
  faUserSlash,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import Country from '../../../components/Country';
import TableManager from '../../../components/TableManager';
import { createTable } from '@tanstack/react-table';
import { Country as GlobalCountries } from 'country-state-city';

const table = createTable();

const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const statusOptions = [
  { label: 'Activated', value: 'A' },
  { label: 'Deactivated', value: 'D' },
  { label: 'Pending', value: 'P' },
];

const initialValues = {
  filter: [
    {
      did_number: '',
      a_filter_type: '',
      placeholder: 'Enter Did Number...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'Did Number',
    },
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      country: '',
      a_filter_type: '',
      placeholder: 'Select Country...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: GlobalCountries?.getAllCountries(),
      label: 'Country',
    },
    {
      did_city: '',
      a_filter_type: '',
      placeholder: 'Enter City...',
      type: 'text',
      shouldFilterOptionDisabled: true,
      label: 'City',
    },
    {
      did_status: '',
      a_filter_type: '',
      placeholder: 'Select Status...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: statusOptions,
      label: 'Status',
    },

    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Select Buy Date...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Buy Date',
    },
    // {
    //   renewal_date: {
    //     from: '',
    //     to: '',
    //   },
    //   a_filter_type: '',
    //   placeholder: 'Select Renewal Date...',
    //   type: 'date',
    //   shouldFilterOptionDisabled: false,
    //   filterOptions: DateFilterTypes,
    //   selectOptions: [],
    //   label: 'Renewal Date',
    // },
  ],
};

const Bought = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [userDetailsModal, setUserDetailsModal] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const { mutateAsync: mutateAsyncdelete } = useMutation(
    'delete-number',
    deleteNumber,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('numberListing');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );
  const { mutateAsync: mutateAsyncUpdate } = useMutation(
    'update-did',
    didUpdate,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('numberListing');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleDeleteNumber = (val) => {
    swal({
      text: 'Are you sure you want to delete this Number ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            didID: val?.didID,
          };
          await mutateAsyncdelete(payload);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const handleProfit = (val) => {
    const { did_setup_cost, did_monthly_cost, amount } = val;
    const profit = amount - (did_setup_cost + did_monthly_cost);
    const inLose = Math.sign(profit);
    if (inLose === -1 || inLose === -0) {
      return (
        <a className="text-danger" href={void 0}>
          {profit.toFixed(2)}
        </a>
      );
    } else {
      return (
        <a className="text-success" href={void 0}>
          {profit.toFixed(2)}
        </a>
      );
    }
  };

  const handleOpenUserDetails = (shouldOpen, data) => {
    if (!shouldOpen) {
      return false;
    }

    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const handleDeactivateBtn = async (data, uniquecode) => {
    let payload = {
      did_status: data,
      uniquecode,
    };
    swal({
      text: 'Do you want to deactivate this DID ?',
      icon: 'warning',
      buttons: true,
    }).then(async (willDeactive) => {
      if (willDeactive) {
        try {
          await mutateAsyncUpdate(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const handleActivateBtn = async (data, uniquecode) => {
    let payload = {
      did_status: data,
      uniquecode,
    };
    swal({
      text: 'Do you want to activate this DID ?',
      icon: 'warning',
      buttons: true,
    }).then(async (willActivate) => {
      if (willActivate) {
        try {
          await mutateAsyncUpdate(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const columns = [
    table.createDataColumn('did_number', {
      id: 'did_number',
      header: 'DID Number',
      textAlign: 'left',
    }),
    table.createDataColumn((row) => row?.customer?.msisdn, {
      id: 'msisdn',
      header: 'MSISDN',
      shouldPointer: true,
      cell: (props) => (
        <span
          className="hover-name"
          onClick={() =>
            handleOpenUserDetails(
              props.getValue(),
              props?.row?.original?.customer,
            )
          }
        >
          {props.getValue()}
        </span>
      ),
    }),
    table.createDataColumn('country', {
      id: 'country',
      header: 'Country',
      textAlign: 'left',
      cell: (props) => <Country isoCode={props.getValue()} />,
    }),
    table.createDataColumn('did_city', {
      id: 'city',
      header: 'City',
      textAlign: 'left',
    }),
    table.createDataColumn('buy_date', {
      id: 'buy_date',
      header: 'Buy Date',
      isSortable: true,
    }),
    table.createDataColumn('renewal_date', {
      id: 'renewal_date',
      header: 'Renewal Date',
      isSortable: true,
    }),
    table.createDataColumn('did_setup_cost', {
      id: 'did_setup_cost',
      header: 'Setup Cost',
      isSortable: true,
    }),
    table.createDataColumn('did_monthly_cost', {
      id: 'did_monthly_cost',
      header: 'Monthly Cost',
      isSortable: true,
    }),
    table.createDataColumn('amount', {
      id: 'amount',
      header: 'Paid',
      isSortable: true,
    }),
    table.createDisplayColumn({
      id: 'profit',
      header: 'Profit',
      cell: (props) => {
        const res = handleProfit(props.row.original);
        return res;
      },
    }),
    table.createDataColumn('did_status', {
      id: 'did_status',
      header: 'Status',
      cell: (props) =>
        props.getValue() === 'A' ? (
          <span className="text-success">Activated</span>
        ) : props.getValue() === 'P' ? (
          <span className="text-warning">Pending</span>
        ) : (
          <span className="text-danger">Deactivated</span>
        ),
    }),
    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {props?.row?.original?.did_status === 'A' ? (
                <Dropdown.Item
                  href={void 0}
                  onClick={() =>
                    handleDeactivateBtn('D', props?.row?.original?.uniquecode)
                  }
                >
                  <FontAwesomeIcon icon={faUserSlash} />
                  Deactivate
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  href={void 0}
                  onClick={() =>
                    handleActivateBtn('A', props?.row?.original?.uniquecode)
                  }
                >
                  <FontAwesomeIcon icon={faUser} />
                  Activate
                </Dropdown.Item>
              )}

              <Dropdown.Item
                href={void 0}
                onClick={() => handleDeleteNumber(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="numberListing"
        fetcherFn={callNumberListing}
        title="Bought DID"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
      />

      {userDetailsModal && (
        <NumberDetails
          userDetailsModal={userDetailsModal}
          setUserDetailsModal={setUserDetailsModal}
          userDetails={userDetails}
          setUserDetails={setUserDetails}
        />
      )}
    </>
  );
};

export default Bought;
